import Vue from 'vue';
import Vuex from 'vuex';
import contacts from './contacts';
import therapists from './therapists';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    contacts,
    therapists,
  }
});

export default store;
